import React from 'react';
import { ChevronsRight, Asterisk, ArrowUpRight } from 'lucide-react';
import { services } from '../data/mock';

const cardPalettes = [
  { card: 'from-rose-50 via-white to-rose-100/80 border-rose-200', orb: 'bg-rose-300/50', icon: 'border-rose-200 shadow-rose-100', code: 'text-rose-700', tag: 'text-rose-700' },
  { card: 'from-amber-50 via-white to-amber-100/80 border-amber-200', orb: 'bg-amber-300/50', icon: 'border-amber-200 shadow-amber-100', code: 'text-amber-700', tag: 'text-amber-700' },
  { card: 'from-sky-50 via-white to-sky-100/80 border-sky-200', orb: 'bg-sky-300/50', icon: 'border-sky-200 shadow-sky-100', code: 'text-sky-700', tag: 'text-sky-700' },
  { card: 'from-emerald-50 via-white to-emerald-100/80 border-emerald-200', orb: 'bg-emerald-300/50', icon: 'border-emerald-200 shadow-emerald-100', code: 'text-emerald-700', tag: 'text-emerald-700' },
  { card: 'from-violet-50 via-white to-violet-100/80 border-violet-200', orb: 'bg-violet-300/50', icon: 'border-violet-200 shadow-violet-100', code: 'text-violet-700', tag: 'text-violet-700' },
  { card: 'from-orange-50 via-white to-orange-100/80 border-orange-200', orb: 'bg-orange-300/50', icon: 'border-orange-200 shadow-orange-100', code: 'text-orange-700', tag: 'text-orange-700' },
];

const Services = () => {
  return (
    <section id="services" className="relative py-16 lg:py-24 bg-white overflow-hidden">
      <div className="absolute -right-40 top-10 w-[460px] h-[460px] rounded-full bg-sky-100/40 blur-3xl pointer-events-none" />
      <div className="absolute -left-40 bottom-10 w-[420px] h-[420px] rounded-full bg-rose-100/50 blur-3xl pointer-events-none" />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-14">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 text-sm font-medium text-[#C41E3A] mb-4">
              <Asterisk className="w-4 h-4" />
              Our Services
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-[3.5rem] font-extrabold text-neutral-900 leading-[1.05]">
              Authority-led compliance services with clear approval routes
            </h2>
          </div>
          <div className="lg:col-span-5 flex flex-col justify-end">
            <p className="text-neutral-600 text-base md:text-lg leading-relaxed mb-6">
              14 core service areas, 20+ approval routes and AMC support — mapped to your product, market and renewal cycle.
            </p>
            <a
              href="/services"
              className="pill-btn group inline-flex items-center gap-2 self-start rounded-full bg-neutral-900 hover:bg-[#C41E3A] text-white pl-5 pr-1 h-11 text-sm font-semibold transition-colors"
            >
              View all services
              <span className="w-9 h-9 rounded-full bg-[#C41E3A] group-hover:bg-white flex items-center justify-center pill-arrow">
                <ChevronsRight className="w-3.5 h-3.5 text-white group-hover:text-[#C41E3A]" />
              </span>
            </a>
          </div>
        </div>

        {/* Services grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {services.map((s, index) => {
            const palette = cardPalettes[index % cardPalettes.length];
            return (
            <a
              key={s.id}
              href={s.href}
              className={`group relative bg-gradient-to-br border rounded-[1.75rem] p-6 pb-7 min-h-[355px] overflow-hidden hover:-translate-y-2 hover:shadow-[0_24px_55px_-28px_rgba(15,23,42,0.32)] transition-all duration-300 ${palette.card}`}
            >
              <div className={`absolute -top-12 -right-12 w-36 h-36 rounded-full blur-xl group-hover:scale-125 transition-transform duration-500 ${palette.orb}`} />
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-white/80 group-hover:bg-[#C41E3A] transition-colors" />

              <div className="relative flex items-center justify-between mb-6">
                <span className={`w-20 h-20 md:w-[88px] md:h-[88px] rounded-[1.4rem] bg-white border flex items-center justify-center p-3 shadow-lg group-hover:scale-105 transition-transform ${palette.icon}`}>
                  <img
                    src={s.logo}
                    alt={s.code}
                    className="w-full h-full object-contain scale-110"
                    onError={(e) => { e.currentTarget.style.display = 'none'; }}
                  />
                </span>
                <span className="text-4xl font-display font-extrabold text-white/90 drop-shadow-sm">{s.id}</span>
              </div>

              <div className="relative">
                <div className={`font-display text-2xl font-extrabold transition-colors mb-1 ${palette.code}`}>
                  {s.code}
                </div>
                <div className="text-sm font-bold text-neutral-900 leading-snug mb-3">{s.name}</div>
                <p className="text-xs text-neutral-600 leading-relaxed mb-5">{s.desc}</p>

                <div className="flex items-center justify-between pt-4 border-t border-neutral-900/10">
                  <span className={`text-[10px] font-bold uppercase tracking-wider ${palette.tag}`}>{s.tag}</span>
                  <span className="w-9 h-9 rounded-full bg-white border border-white shadow-sm group-hover:bg-[#C41E3A] group-hover:border-[#C41E3A] flex items-center justify-center transition-all">
                    <ArrowUpRight className="w-4 h-4 text-neutral-600 group-hover:text-white group-hover:rotate-45 transition-all" />
                  </span>
                </div>
              </div>
            </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
